import {useEffect} from 'react';
import {getEoyLog} from '../actions/wizardLog';
import {formsStore} from '../../../stores/Form/FormsStore';
import {useFooterContext} from './useFooterContext';
import {FiscalYearState} from '../Components';

export const useFiscalYear = (): [boolean, FiscalYearState | undefined] => {
    const {
        fiscalYearState: {state, setState, isLoaded, setIsLoaded}
    } = useFooterContext();

    useEffect(() => {
        if (!isLoaded || !state) {
            setState(undefined);
            getEoyLog().then(form => {
                if (form) {
                    const records = form.records.filter(x => !x.isNew);
                    const parseState = (record: (typeof records)[0]) => {
                        const yearColumnId = form.columns.find(x => x.Name === 'GLNAME').id;
                        const startDateColumnId = form.columns.find(x => x.Name === 'SDATE').id;
                        const endDateColumnId = form.columns.find(x => x.Name === 'EDATE').id;
                        const prevStartDateColumnId = form.columns.find(
                            x => x.Name === 'SDATEOLD'
                        ).id;
                        const prevEndDateColumnId = form.columns.find(
                            x => x.Name === 'EDATEOLD'
                        ).id;
                        const prefixColumnId = form.columns.find(x => x.Name === 'PREFIX').id;
                        const existYearColumnId = form.columns.find(
                            x => x.Name === 'EXISTSYEAR'
                        ).id;
                        const subCompanyFlagColumnnID = form.columns.find(
                            x => x.Name === 'COMPANYFLAG'
                        ).id;
                        const nscustColumnId = form.columns.find(x => x.Name === 'NSCUST').id;
                        const exttypeColumnId = form.columns.find(x => x.Name === 'EXTTYPE').id;

                        return {
                            year: record.getField(yearColumnId).currentValue as string,
                            startDate: record.getField(startDateColumnId).currentValue as string,
                            endDate: record.getField(endDateColumnId).currentValue as string,
                            prefix: record.getField(prefixColumnId).currentValue as string,
                            existYearFlag: record.getField(existYearColumnId)
                                .currentValue as boolean,
                            subCompanyFlag: record.getField(subCompanyFlagColumnnID)
                                .currentValue as boolean,
                            nscust: record.getField(nscustColumnId).currentValue as string,
                            exttype: record.getField(exttypeColumnId).currentValue as string,
                            prevStartDate: record.getField(prevStartDateColumnId)
                                .currentValue as string,
                            prevEndDate: record.getField(prevEndDateColumnId).currentValue as string
                        };
                    };

                    setState(parseState(records[0]));
                    formsStore.deleteForm(form.session);
                    setIsLoaded(true);
                }
            });
        }
    }, [!isLoaded]);

    return [isLoaded, state];
};
